import { gql } from "@apollo/client";

export const CATEGORY_INSTALL_COUNT_QUERY = gql`
  query categoryInstallCount(
    $categoryIds: [Identifier]!
    $localizeInstalls: Boolean!
  ) {
    productCatalogInstallsCount(
      categoryIds: $categoryIds
      localizeInstalls: $localizeInstalls
    ) {
      count
    }
  }
`;
